import React from 'react'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import Link from 'next/link'
import { isProductInCart } from '../../utils/cart'
import Product from '../Product'
import Title from '../Title'

import style from './style.scss'

export default function Products({
  title,
  data,
  domain,
  activeOrder,
  cartItems,
  handleOrder,
  handleAddProduct,
  giftsAvailable,
  redirectToPage

}) {
  return (
    <div className={style.products}>
      <Title title={title} />
      <div className={style.sortList}>
        <div className={`${style.sortButtons}`}>
          <p className={style.sortBy}>Ordenar por R$:</p>
          <button
            type="button"
            onClick={() => handleOrder('asc')}
            className={`${style.btnOutline} ${activeOrder === 'asc' ? 'active' : ''
              } title-button`}
          >
            menor
          </button>
          <button
            type="button"
            onClick={() => handleOrder('desc')}
            className={`${style.btnOutline} ${activeOrder === 'desc' ? 'active' : ''
              } title-button`}
          >
            maior
          </button>
        </div>
      
        <button
          type="button"
          onClick={() => {
            window.location.href = '/checkout/cart'
          }}
          className={`${style.btnCart} ${'active'} title-button`}
        >
          <ShoppingCartOutlinedIcon fontsize="large" />
          {/* <span>Carrinho</span> */}
        </button>
      </div>
      {redirectToPage && (
        <div className={style.buttonGo}>
          <Link href={redirectToPage} passHref>
            <a title="voltar" className={`${style.button} title-bg-button`}>
              voltar
            </a>
          </Link>
        </div>
      )}
      {!giftsAvailable && (
        <p className={`${style.siteWarning}`}> ... </p>)
      }
      <div className={style.productsList}>
        <If condition={data.length > 0}>
          {data.map((product) => (
            <Product
              key={product.present_id}
              id={product.present_id}
              image={`${domain}${product.present.image_public}`}
              title={product.present.name}
              description={product.present.description}
              price={product.present.price}
              quantity={product.quantity}
              quantityBought={product.quantity_bought}
              handleAddProduct={handleAddProduct}
              inCart={isProductInCart(product.present_id, cartItems)}
            // giftsAvailable={giftsAvailable}
            />
          ))}
        </If>
      </div>
    </div>
  )
}
